import { SurveysRoutes } from './type'

const surveys = `${SurveysRoutes.root}`
const edit = (id: number) => `${surveys}/${SurveysRoutes.edit}/${id}`

export const SurveysPath = {
  root: surveys,
  create: `${surveys}/${SurveysRoutes.create}`,
  edit: edit,
  view: `${surveys}/${SurveysRoutes.view}`,
}
